export enum NotifyType {
    UNKNOWN,
    ERROR,
    SUCCESS,
    INFO,
    WARNING
}